// History page content.
// NOTE: This is PLACEHOLDER / FILLER copy for design-demo purposes only.
// Dates, summaries, and highlight stats are illustrative and should be replaced
// with the client's real history content. Photos reuse existing worldfarmers.org
// imagery (black-and-white shots are used for the earlier "archival" eras).

export const HISTORY_INTRO = {
  eyebrow: "",
  title: "Our History",
  lede: "Four decades in the fields.",
  summary:
    "Although World Farmers was founded as a non-profit in 2010, our history dates to 1984. Our program did not begin in the traditional spirit of a program or organization; it all began because of the bravery of a refugee farmer in asking for land when her family and community had a great need, and the kindness of an immigrant farmer who offered land because they knew what it was like to lack. Driven by a need to connect with the land and her cultural history, this Hmong farmer, a Vietnam War refugee, marks the very first farmer on our founding program landsite, a 70-acre river bottom parcel in Lancaster, MA, known today as Flats Mentor Farm. What began as an act of generosity, grew to become an ambitious project to welcome farmers from various backgrounds, foster knowledge-sharing across cultures, and provide an opportunity for immigrants and refugees from agrarian backgrounds to continue to farm as a way of life in the US. Dive into our long and rich history through our timeline.",
  heroImage: "/images/wf/farm-2611.jpg",
  heroAlt:
    "A silhouette of a farmer working in a field during a vibrant, sun-drenched sunrise.",
};

export const HISTORY_TIMELINE = [
  {
    year: "1984",
    text: "First refugee farmer began growing at Flats Mentor Farm.",
    detail:
      "Our history began because of the bravery of a refugee farmer in asking for land when her family and community had a great need, and the kindness of an immigrant farmer who offered land because they knew what it was like to lack. This Hmong farmer, a Vietnam War refugee, marks the very first farmer on our founding program landsite — a 70-acre river-bottom parcel in Lancaster, MA, known today as Flats Mentor Farm.",
    photos: [
      { src: "/images/wf/farm-017.jpg", alt: "A farmer smiling warmly while standing in a lush agricultural field." },
      { src: "/images/wf/farm-035.jpg", alt: "A farmer holding freshly harvested greens in the field." },
      { src: "/images/wf/farm-2611.jpg", alt: "A farmer silhouetted against a glowing sunrise over the fields." },
    ],
  },
  {
    year: "1993",
    text: "190 Hmong refugee families farm the land.",
    photos: [
      { src: "/images/wf/vlai/vlai-3766.jpg", alt: "A farmer harvesting from tall trellised vines on a bright day." },
    ],
  },
  {
    year: "1999",
    text: "Program recognized by USDA as a national model for beginning-farmer programs.",
    photos: [
      { src: "/images/wf/farm-159.jpg", alt: "A farmer in a wide-brimmed hat tending rows of crops at golden hour." },
    ],
  },
  {
    year: "2001",
    text: "First farmer attends an area farmers’ market.",
    photos: [
      { src: "/images/wf/vlai/vlai-3647.jpg", alt: "A farmer in a floral sun hat looking up from harvesting peppers." },
      { src: "/images/wf/vlai/vlai-3626.jpg", alt: "Freshly harvested vegetables ready for market." },
    ],
  },
  {
    year: "2005",
    text: "Farmers form a collective marketing strategy under the banner “Flats Mentor Farm.”",
    photos: [
      { src: "/images/wf/who-we-are.jpg", alt: "A smiling farmer carrying a large bag of freshly harvested corn." },
    ],
  },
  {
    year: "2010",
    text: "World Farmers is established as a non-profit organization.",
    detail:
      "What began as an act of generosity grew into an ambitious project: to welcome farmers from various backgrounds, foster knowledge-sharing across cultures, and provide an opportunity for immigrants and refugees from agrarian backgrounds to continue to farm as a way of life in the US.",
    photos: [
      { src: "/images/wf/farm-3503.jpg", alt: "Farmers working together across the fields at the Flats." },
      { src: "/images/wf/vlai/vlai-3537.jpg", alt: "A weathered wooden cart resting among tall grasses at the edge of a field." },
      { src: "/images/wf/vlai/vlai-3744.jpg", alt: "A farmer smiling while holding a long, freshly harvested gourd." },
    ],
  },
  {
    year: "2012",
    text: "Initiate wholesale sales to area stores and grocers.",
    photos: [
      { src: "/images/wf/vlai/vlai-3483.jpg", alt: "A farmer sorting a pile of freshly cut greens at the edge of a field." },
    ],
  },
  {
    year: "2014",
    text: "Launch our first CSA season.",
    photos: [
      { src: "/images/wf/farm-3634.jpg", alt: "A colorful spread of just-harvested produce." },
      { src: "/images/wf/farm-3754.jpg", alt: "Boxes of fresh vegetables prepared for distribution." },
    ],
  },
  {
    year: "2016",
    text: "Program farmers attend 42 farmers’ markets across the state.",
    photos: [
      { src: "/images/wf/vlai/vlai-3786.jpg", alt: "A farmer carrying freshly harvested gourds through the field." },
    ],
  },
  {
    year: "2018",
    text: "Purchase of 2 acres of tillable land in the area.",
    photos: [
      { src: "/images/wf/farm-91.jpg", alt: "An open field of tilled soil ready for planting." },
    ],
  },
  {
    year: "2019",
    text: "Second multi-phase program farmsite is established.",
    photos: [
      { src: "/images/wf/vlai/vlai-3532.jpg", alt: "A farmer in a floral sun hat carrying an armful of greens through the field." },
      { src: "/images/wf/vlai/vlai-3514.jpg", alt: "Rows of healthy crops stretching toward the tree line." },
    ],
  },
  {
    year: "2020",
    text: "Operate food-distribution programming with community partners across the state.",
    photos: [
      { src: "/images/wf/farm-007.jpg", alt: "Farmers preparing bundles of produce for the community." },
      { src: "/images/wf/farm-3777.jpg", alt: "Fresh produce packed and ready for distribution." },
    ],
  },
  {
    year: "2021",
    text: "World Farmers establishes a land license with MDAR.",
    photos: [
      { src: "/images/wf/vlai/vlai-3851.jpg", alt: "A broad view across the farm landsite under an open sky." },
    ],
  },
  {
    year: "2022",
    text: "Expand the Food is Medicine program in partnership with Just Roots.",
    photos: [
      { src: "/images/wf/farmers/fabiola-high-tunnel-crops.jpg", alt: "Crops thriving inside a high tunnel." },
      { src: "/images/wf/farmers/fabiola-high-tunnel-inside.jpg", alt: "The interior of a high tunnel full of growing plants." },
      { src: "/images/wf/farmers/fabiola-high-tunnel-opening.jpg", alt: "A farmer standing at the opening of a high tunnel." },
    ],
  },
  {
    year: "2023",
    text: "Farmers experience a historic and devastating flood in July.",
    photos: [
      { src: "/images/wf/vlai/vlai-3575.jpg", alt: "A quiet, water-soaked field after heavy summer rains." },
    ],
  },
  {
    year: "2026",
    text: "Establish institutional buyer partnerships.",
    photos: [
      { src: "/images/wf/vlai/vlai-3764.jpg", alt: "A farmer proudly presenting a fresh harvest." },
      { src: "/images/wf/vlai/vlai-3765.jpg", alt: "Crates of produce ready for an institutional buyer." },
    ],
  },
];
